import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { REDIRECT_CLIENT_URL, BRAND_NAME, TIMER_MS_SSO } from '../../../constants';
import { COOKIE_KEY_REDIRECT_AFTER_LOGIN } from '../../../constants/cookie';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import { Logo } from '../../icons/Logo';

import { LoginModalComponentContainer } from './LoginModalComponentStyle';

class LoginModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectionTimer: null
        };
    }

    componentDidMount() {
        const { redirectAfterLogin } = this.props;

        if (redirectAfterLogin) {
            sessionStorage.setItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN, redirectAfterLogin);
        } else {
            sessionStorage.setItem(COOKIE_KEY_REDIRECT_AFTER_LOGIN, this.props.location.pathname);
        }

        if (REDIRECT_CLIENT_URL) {
            this.redirect(this.props.redirectUrl, TIMER_MS_SSO);
        }
    }

    redirect = (url, time) => {
        if (url) {
            console.log('Will be redirect in 5 seconds to', url);

            this.setState({
                redirectionTimer: setTimeout(() => {
                    window.location = url;
                }, time)
            });
        } else {
            console.error('An error occured, no redirection');
        }
    };

    componentWillUnmount() {
        // When close the modal, clear the timeout redirection
        clearTimeout(this.state.redirectionTimer);
    }

    getMainText = () => {
        const { redirectUrl, i18n } = this.props;

        if (redirectUrl && !REDIRECT_CLIENT_URL) {
            return convertHtmlToReactDomWithParams(i18n.NO_REDIRECT, redirectUrl);
        }

        return convertHtmlToReactDomWithParams(i18n.MUST_BE_LOGGED_IN, BRAND_NAME);
    };

    render() {
        const { redirectUrl, i18n } = this.props;

        return (
            <LoginModalComponentContainer>
                <Logo center />

                <p className="log-in">{this.getMainText()}</p>

                {redirectUrl && REDIRECT_CLIENT_URL && (
                    <React.Fragment>
                        <p className="small">{i18n.REDIRECT}</p>
                        <p className="small">
                            {i18n.IF_NOT} <a href={redirectUrl}>{i18n.CLICK_HERE}</a>.
                        </p>
                    </React.Fragment>
                )}
            </LoginModalComponentContainer>
        );
    }
}

LoginModalComponent.propTypes = {
    redirectUrl: PropTypes.string.isRequired,
    redirectAfterLogin: PropTypes.string,
    i18n: PropTypes.object
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.login,
        location: state.routing.location
    };
};

export default connect(mapStateToProps)(LoginModalComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/login/LoginModalComponent.js